<template>
  <div class="flex-1 flex items-center justify-center px-5 text-center">
    <div class="w-full">
      <h2 class="text-2xl font-bold text-foreground mb-2 leading-tight">
        {{ displayTitle }}
      </h2>
      <p
        v-if="displaySubtitle"
        class="text-base text-muted-foreground mb-8 leading-relaxed"
      >
        {{ displaySubtitle }}
      </p>

      <div v-if="defaultQuestions.length" class="flex flex-col gap-3 w-full">
        <GradientButton
          v-for="question in defaultQuestions"
          :key="question"
          size="default"
          multiline
          full-width
          class="rounded-2xl"
          @click="handleQuestionClick(question)"
          :disabled="isLoading"
        >
          {{ question }}
        </GradientButton>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useChatbot } from '@/composables/useChatbot'
import { GradientButton } from '@/lib/ui'
import { CHATBOT_CONSTANTS } from '@/types/constants'
import type { IWelcomeMessagesProps, IWelcomeMessagesEmits } from './types'

const props = defineProps<IWelcomeMessagesProps>()

const emit = defineEmits<IWelcomeMessagesEmits>()

const chatbot = useChatbot()

const displayTitle = computed(() => {
  return (
    props.config?.welcomeConfiguration?.title ||
    chatbot.store.brand?.name ||
    CHATBOT_CONSTANTS.WELCOME.TITLE
  )
})

const displaySubtitle = computed(() => {
  return (
    props.config?.welcomeConfiguration?.subtitle ||
    CHATBOT_CONSTANTS.WELCOME.SUBTITLE
  )
})

const defaultQuestions = computed(() => {
  return (
    props.config?.welcomeConfiguration?.questions ||
    chatbot.store.defaultQuestions ||
    []
  )
})

const handleQuestionClick = (question: string) => {
  emit('question-click', question)
}
</script>

<style>
/* Reduced motion */
@media (prefers-reduced-motion: reduce) {
  button {
    transition: none;
  }

  button:hover {
    transform: none;
  }
}
</style>
